import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Different granularities to classify how a space is used (e.g., Lab Space, Office, Classroom, etc.).',
    name: 'Space Use',
    partialId: PartialId.Standard.create('space_use'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
